// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui.button.basic.link, .ui.button.basic.link:hover, .ui.button.basic.link:focus {\n    box-shadow: 0 0 !important;\n  }", ""]);
// Exports
module.exports = exports;
